import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { academyInfo } from '../data/mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCall = () => {
    window.location.href = `tel:${academyInfo.phone}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/91${academyInfo.whatsapp}?text=Hi, I want to enquire about stock market courses`, '_blank');
  };

  const navLinks = [
    { name: 'Home', href: '/#home' },
    { name: 'Courses', href: '/#courses' },
    { name: 'Why Choose Us', href: '/#why-choose' },
    { name: 'Reviews', href: '/#testimonials' },
    { name: 'Blog', href: '/blog' },
    { name: 'Location', href: '/#location' },
    { name: 'Enquire', href: '/#enquiry' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white shadow-lg py-3' 
          : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo/Brand */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center gap-3">
              <img 
                src="/images/logo.png" 
                alt="Stocks Vision Academy Logo" 
                className="h-12 sm:h-14 w-auto"
              />
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold text-gray-900">
                  <span className="text-green-600">Stocks Vision</span> Academy
                </h1>
                <p className="text-xs text-gray-600">Stock Market Training - Bhopal</p>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-gray-700 hover:text-green-600 font-medium transition-colors"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Buttons - Desktop */}
          <div className="hidden md:flex items-center gap-3">
            <Button
              onClick={handleCall}
              variant="outline"
              size="sm"
              className="border-2 border-green-600 text-green-700 hover:bg-green-50"
            >
              <Phone className="h-4 w-4 mr-2" />
              Call
            </Button>
            <Button
              onClick={handleWhatsApp}
              size="sm"
              className="bg-green-600 hover:bg-green-700 text-white"
            >
              <MessageCircle className="h-4 w-4 mr-2" />
              WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-green-600"
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <nav className="flex flex-col gap-3 mb-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-700 hover:text-green-600 font-medium transition-colors py-2"
                >
                  {link.name}
                </a>
              ))}
            </nav>
            <div className="flex flex-col gap-2">
              <Button
                onClick={handleCall}
                variant="outline"
                className="w-full border-2 border-green-600 text-green-700 hover:bg-green-50"
              >
                <Phone className="h-4 w-4 mr-2" />
                Call: {academyInfo.phone}
              </Button>
              <Button
                onClick={handleWhatsApp}
                className="w-full bg-green-600 hover:bg-green-700 text-white"
              >
                <MessageCircle className="h-4 w-4 mr-2" />
                WhatsApp Now
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
